import React, { Component } from "react";
import "../style/home.scss";
import EarthIcon from "../icon/EarthIcon";
import * as GetStoryListAPI from "../apis/GetStoryListAPI";
import { BASE_URL, STORY_URL } from "../constants/ApiEndpointConstants";
import * as GetCommentListAPI from "../apis/GetCommentListAPI";
import moment from "moment-timezone";
import Loading from "./common/Loading";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss/autoplay";
import i5M60 from "../image/bmw-i5-m60.png";
import ixM60 from "../image/bmw-ix-m60.png";
import i4 from "../image/bmw-i4.png";
import bmw3 from "../image/bmw3.png";
import FootBar from "./common/FootBar";
import { routePage } from "../utils/routePage";
import safeParse from "../utils/SafeParseLocalstrorage";
import "moment/locale/en-gb"; // 引入locale
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import { lang } from "../utils/lang";
import getAd from "../utils/GetAd";
import TeslaIcon from "../icon/TeslaIcon";
import { getBrowserRegion } from "../utils/BrowserRegion";
import PagePath from "../constants/router/PagePath";
import { connect } from "react-redux";

import * as FacebookAPI from "../apis/FacebookAPI";

import * as PostMessageAPI from "../apis/PostMessageAPI";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingShow: false,
      story: {},
      commentList: [],
      storyTime: "",
      driveNum: "",
      swiperList: [i5M60, ixM60, bmw3, i4],
      cartMask: false,
      groupid: safeParse("groupid"),
      ad: getAd(),
      country: props.countryCode || "US",
    };
    this.changeLoveState = this.changeLoveState.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.scroll = this.scroll.bind(this);
    this.changeCartMask = this.changeCartMask.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidMount() {
    // PostMessageAPI.postMessage(`${BASE_URL} [Story Page]`, this.state.groupid);
    window.scrollTo(0, 0);
    const { timeZone, momentLocale } = getBrowserRegion();
    let { country } = this.state;
    moment.locale(momentLocale);
    // 试驾数
    let driveNum = Math.floor(Math.random() * (50 - 200 + 1)) + 200;
    // 获取当前时间戳
    let now = new Date().getTime();
    // 获取前后n天时间
    let endTime = new Date(now - 10 * 24 * 60 * 60 * 1000).getTime();
    let startTime = new Date(now - 13 * 24 * 60 * 60 * 1000).getTime();
    let oneDayTime = new Date(now - 1 * 24 * 60 * 60 * 1000).getTime();
    // 随机帖子时间
    let renderTime =
      Math.floor(Math.random() * (endTime - startTime + 1)) + startTime;
    // 格式化
    let storyTime = moment(renderTime).tz(timeZone).format("LLL");
    this.setState({ storyTime, driveNum });
    let time = [renderTime, now];
    this.setState({ loadingShow: true });
    // 根据国家筛选帖子
    GetStoryListAPI.getStoryList({
      country_code: country,
      category_name: "TESLA",
    })
      .then((res) => {
        var code = res.data.code;
        if (code === 1) {
          var data = res.data.data;
          let id = data.list[0].id;
          this.setState({ story: data.list[0] }, () => {
            GetCommentListAPI.getCommentListAPI(id).then((res) => {
              var code = res.data.code;
              if (code === 1) {
                var data = res.data.data.list;
                data.map((item, index) => {
                  item.loveState = false;
                  // 点赞数
                  item.num = Math.floor(Math.random() * (50 - 200 + 1)) + 200;
                  let render =
                    Math.floor(Math.random() * (time[1] - time[0] + 1)) +
                    time[0];
                  if (index < 3) {
                    render =
                      Math.floor(Math.random() * (time[1] - oneDayTime + 1)) +
                      oneDayTime;
                    if (render < time[1]) {
                      time[1] = render;
                      item.time = moment(render).tz(timeZone).fromNow();
                    }
                  } else {
                    if (render < time[1]) {
                      time[1] = render; // 具体时间格式
                      item.time = moment(render).tz(timeZone).format("LLL");
                    }
                  }
                });
                this.setState({ commentList: data });
              }
            });
          });
        }
      })
      .catch((error) => {
        console.error("Failed to load home content:", error);
      })
      .finally(() => {
        this.setState({ loadingShow: false });
      });
    window.addEventListener("scroll", this.scroll, true);
  }

  changeLoveState(index) {
    let { commentList } = this.state;
    commentList.map((item, itemIndex) => {
      if (index === itemIndex) {
        item.loveState = !item.loveState;
        if (item.loveState === true) {
          item.num++;
          return;
        } else {
          return item.num--;
        }
      }
    });
    this.setState({ commentList });
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scroll, true);
  }

  scroll() {
    setTimeout(() => {
      this.setState({ cartMask: true });
    }, 3000);
  }

  changeCartMask() {
    setTimeout(this.setState({ cartMask: !this.state.cartMask }), 3000);
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  render() {
    const {
      story,
      commentList,
      storyTime,
      driveNum,
      swiperList,
      cartMask,
      ad,
    } = this.state;
    let { history, location } = this.props;
    return (
      <React.Fragment>
        <Loading {...this.props} loadingShow={this.state.loadingShow} />

        <div className="home">
          <div className="home-page">
            <div className="head">
              <div className="img">
                <TeslaIcon width={120} height={35} color="white" />
                <div
                  className="animate-button"
                  style={{ backgroundColor: "rgb(210, 15, 39)" }}
                  onClick={() => routePage(history, ad, PagePath.TESLA)}
                >
                  {lang.homeButton}
                </div>
              </div>
            </div>
            <div className="content">
              <div className="logo">
                <img src={STORY_URL + story?.logo} alt="" />
                <p className="logo-title">{lang.homeLogoTitle}</p>
              </div>

              <div className="story-content">
                <p dangerouslySetInnerHTML={{ __html: story.description }}></p>
              </div>
              <div className="comment-content">
                <div className="comment-ul">
                  {commentList &&
                    commentList.map((item, index) => {
                      return (
                        <div className="comment-li" key={index}>
                          <div className="profile-img">
                            <img src={STORY_URL + item.logo} alt="" />
                          </div>
                          <div className="li-txt">
                            <div className="name">{item.nickname}</div>
                            <div
                              className="content-txt"
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            ></div>
                            <div className="time-box">
                              <div className="icon-box">
                                <EarthIcon size={13} color="#737b8b" />
                              </div>
                              <p className="time-p">{item.time}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              <FootBar {...this.props} />
            </div>
          </div>
        </div>
        <div className="btn-model">
          <div
            className="apply-btn"
            style={{ backgroundColor: "rgb(210, 15, 39)" }}
            onClick={() => routePage(history, ad, PagePath.TESLA)}
          >
            {lang.homeButton}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  countryCode: state.country.code,
});

export default connect(mapStateToProps)(Home);
